

import HexCard from "../../../../components/HexCard";
import HexTitle from "../../../../components/HexTitle";

import { getLabel } from "../../../../hooks/use-labels";

import SummaryList from "../../Components/SummaryList";
import "./style.css";

const SummaryCard = ({ carts, orderInformation }) => {
  const { supplier } = carts.cartProducts[0].product;

  return (
    <div className="order-summary-card">
      <HexCard
        className={
          "first-card content-card card-bottom-divider order-summary-title"
        }
      >
        <HexTitle
          title={getLabel("orderSummaryLabel")}
          className={"font-20-bold-500"}
        />
      </HexCard>

      <HexCard className={"last-card order-summary-list"}>
        <SummaryList detail={{ ...orderInformation, supplier }} />
      </HexCard>
    </div>
  );
};

export default SummaryCard;
